module.exports = __webpack_public_path__ + "img/graphic-2.92d0cc64.svg";